import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineLoadingCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M14.825 8A6.825 6.825 0 1 0 8 14.825M10.1 14.496a6.8 6.8 0 0 0 1.882-.953M14.496 10.1a6.8 6.8 0 0 1-.952 1.881" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineLoadingCircle;
